import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  CreditCard,
  Users,
  Wallet,
  Mail,
  Menu,
} from "lucide-react";

const items = [
  { name: "Accueil", path: "/admin", icon: LayoutDashboard },
  { name: "Tx", path: "/admin/transactions", icon: CreditCard },
  { name: "Users", path: "/admin/users", icon: Users },
  { name: "Wallets", path: "/admin/wallets", icon: Wallet },
  { name: "Emails", path: "/admin/send-emails", icon: Mail },
];

export default function AdminBottomNav({ onOpenMenu }) {
  const location = useLocation();

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 md:hidden border-t border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900">
      <div className="grid grid-cols-6">
        {items.map((it) => {
          const Icon = it.icon;
          const active = location.pathname === it.path || location.pathname.startsWith(it.path + "/");

          return (
            <NavLink
              key={it.path}
              to={it.path}
              className={`flex flex-col items-center justify-center py-2 text-xs ${
                active
                  ? "text-blue-600 dark:text-blue-400"
                  : "text-gray-600 dark:text-gray-300"
              }`}
            >
              <Icon className="w-5 h-5 mb-0.5" />
              <span>{it.name}</span>
            </NavLink>
          );
        })}

        {/* "More" opens sidebar */}
        <button
          type="button"
          onClick={onOpenMenu}
          className="flex flex-col items-center justify-center py-2 text-xs text-gray-600 dark:text-gray-300"
        >
          <Menu className="w-5 h-5 mb-0.5" />
          <span>Menu</span>
        </button>
      </div>
    </div>
  );
}
